<template>
  <div class="vue-password" :class="{ 'vue-password--with-toggle': !disableToggle }">
    <Password
      ref="passwordInput"
      :model-value="modelValue"
      fluid
      @update:model-value="$emit('update:modelValue', $event)"
      :input-class="classes"
      :feedback="!disableStrength"
      :toggle-mask="false"
      :input-id="id"
      :input-props="mergedInputProps"
    />
    <button
      v-if="!disableToggle"
      ref="toggleButton"
      type="button"
      class="p-password-toggle-mask-icon vue-password-toggle"
      :class="unmasked ? 'p-password-mask-icon' : 'p-password-unmask-icon'"
      :tabindex="toggleTabindex"
      :aria-label="unmasked ? $t('Accessibility/General.Hide password') : $t('Accessibility/General.Show password')"
      :aria-pressed="unmasked"
      @click="toggleMask"
    >
      <EyeSlashIcon v-if="unmasked" aria-hidden="true" />
      <EyeIcon v-else aria-hidden="true" />
    </button>
  </div>
</template>

<script>
import EyeIcon from '@primevue/icons/eye'
import EyeSlashIcon from '@primevue/icons/eyeslash'
import Password from 'primevue/password'

export default {
  name: 'VuePassword',
  inheritAttrs: false,
  components: { Password, EyeIcon, EyeSlashIcon },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: 'form-control'
    },
    disableStrength: {
      type: [Boolean, String],
      default: false
    },
    disableToggle: {
      type: [Boolean, String],
      default: false
    },
    spellcheck: {
      type: [Boolean, String],
      default: false
    },
    id: String,
    tabindex: {
      type: [Number, String],
      default: undefined
    }
  },
  emits: ['update:modelValue'],
  expose: ['getInput'],
  data () {
    return {
      unmasked: false
    }
  },
  computed: {
    mergedInputProps () {
      const props = { spellcheck: this.spellcheck }
      if (this.tabindex != null && this.tabindex !== '') {
        props.tabindex = this.tabindex
      }
      return props
    },
    toggleTabindex () {
      if (this.tabindex != null && this.tabindex !== '') {
        return Number(this.tabindex) + 1
      }
      return undefined
    }
  },
  methods: {
    getInput () {
      return this.$refs.passwordInput?.$refs?.input
    },
    toggleMask () {
      this.unmasked = !this.unmasked
      if (this.$refs.passwordInput) {
        this.$refs.passwordInput.unmasked = this.unmasked
      }
    }
  }
}
</script>

<style scoped>
.vue-password {
  display: block;
  width: 100%;
}

.vue-password--with-toggle {
  position: relative;
}

.vue-password :deep(.p-password) {
  width: 100%;
}

.vue-password :deep(.p-password-input),
.vue-password :deep(input.p-inputtext) {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.vue-password--with-toggle :deep(.p-password-input),
.vue-password--with-toggle :deep(input.p-inputtext) {
  padding-inline-end: 2.5rem;
}

.vue-password-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  inset-inline-end: 0.75rem;
  margin-top: -0.5rem;
  width: 1rem;
  height: 1rem;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1;
}
</style>
